import React, { JSX } from 'react';
import Skeleton from 'react-loading-skeleton';
import Styles from './SkeletonLoader.module.scss';

const SkeletonLoader = ({ count = 1 , stylename = '' }: any): JSX.Element => {
  return (
    <div>
      <Skeleton className={`${Styles.reactloadingskeletonV3} ${stylename}`} count={count} />
    </div>
  );
};

export default SkeletonLoader;
